import { render } from "./AccountManagersEditor.vue?vue&type=template&id=24328bf4&scoped=true"
import script from "./AccountManagersEditor.vue?vue&type=script&lang=js"
export * from "./AccountManagersEditor.vue?vue&type=script&lang=js"

import "./AccountManagersEditor.vue?vue&type=style&index=0&id=24328bf4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-24328bf4"

export default script